export default __webpack_public_path__ + "fonts/a3e9898d977dc587db45d58a4658fb39.svg";